﻿document.addEventListener('DOMContentLoaded', () => {
    const $navbarDropdowns = Array.prototype.slice.call(document.querySelectorAll('.has-dropdown-menu'), 0);

    if ($navbarDropdowns.length > 0) {
        $navbarDropdowns.forEach(el => {
            el.addEventListener('click', (event) => {
                $navbarDropdowns.forEach(otherEl => {
                    if (otherEl != el) {
                        otherEl.classList.remove('is-active');
                    }
                });

                el.classList.toggle('is-active');
            });
        });

        document.addEventListener('click', (event) => {
            var isClickInside = false;

            $navbarDropdowns.forEach(el => {
                if (el.contains(event.target)) {
                    isClickInside = true
                }
            });

            if (!isClickInside) {
                $navbarDropdowns.forEach(el => {
                    el.classList.remove('is-active');
                });
            }
        });
    }
});